var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c(
        "article",
        { staticClass: "tile is-child box" },
        [
          _c("div", { staticClass: "columns is-gapless" }, [
            _c("div", { staticClass: "column" }, [
              _c("p", { staticClass: "title" }, [_vm._v("Items Overview")]),
              _c("div", { staticClass: "tabs is-boxed" }, [
                _c("ul", [
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.otherPurchasesItems.length > 0,
                          expression: "otherPurchasesItems.length > 0",
                        },
                      ],
                      class: {
                        "is-active": _vm.activeTab === "OtherPurchases",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabClicked("OtherPurchases")
                            },
                          },
                        },
                        [_vm._v("Other Purchases")]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.partItems.length > 0,
                          expression: "partItems.length > 0",
                        },
                      ],
                      class: {
                        "is-active":
                          _vm.activeTab === _vm.itemCategoryTypes.PART,
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabClicked(_vm.itemCategoryTypes.PART)
                            },
                          },
                        },
                        [_vm._v("Part")]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.miscItems.length > 0,
                          expression: "miscItems.length > 0",
                        },
                      ],
                      class: {
                        "is-active":
                          _vm.activeTab === _vm.itemCategoryTypes.MISC,
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabClicked(_vm.itemCategoryTypes.MISC)
                            },
                          },
                        },
                        [_vm._v("Misc")]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.subletItems.length > 0,
                          expression: "subletItems.length > 0",
                        },
                      ],
                      class: {
                        "is-active":
                          _vm.activeTab === _vm.itemCategoryTypes.SUBL,
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabClicked(_vm.itemCategoryTypes.SUBL)
                            },
                          },
                        },
                        [_vm._v("Sublet")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm.isOtherPurchases
            ? _c("overview-other-purchases", {
                attrs: { value: _vm.value, "item-type": _vm.activeTab },
              })
            : _vm._e(),
          _vm.isPart
            ? _c("overview-part", {
                attrs: { value: _vm.value, "item-type": _vm.activeTab },
              })
            : _vm._e(),
          _vm.isMisc
            ? _c("overview-misc", {
                attrs: { value: _vm.value, "item-type": _vm.activeTab },
              })
            : _vm._e(),
          _vm.isSublet
            ? _c("overview-sublet", {
                attrs: { value: _vm.value, "item-type": _vm.activeTab },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }